var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"12","lg":"12"}},[_c('ClientDetail',{attrs:{"client":_vm.client,"invoices":_vm.invoices,"cifs":_vm.cifs,"loading":_vm.loading}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }